import { useEffect, useState } from 'react';

/**
 * `navigator.onLine` only tells you the device has *a* network, not that the
 * house is reachable — so this is used for the "no internet" screen, while the
 * websocket's own state drives the "reconnecting" banner.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const up = (): void => setOnline(true);
    const down = (): void => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);

  return online;
}
